<template>
	<download-excel
       class="export-excel-wrapper"
       :data = "json_data"
       :fields = "json_fields"
       :name="name_title+'.xls'">
       <el-button type="primary" size="mini">导出</el-button>
     </download-excel>
</template>

<script>
export default {
	data () {
		return {
		}
	},
	props: {
		name:{
			type: String,
			default:'',
		},
		json_fields:{
			type:Object,
			defaul:()=>{},
		},
		json_data:{
			type:Array,
			defaul:()=>[],
		},
	},
	computed: {
	    name_title(){
			var t =new Date();
			var y = t.getFullYear();    //年
			var m = t.getMonth()+1;    // 月
			var d = t.getDate();    //日
			var h = t.getHours();    //时
			var i = t.getMinutes();    //分
			var s = t.getSeconds();   //秒
			var date= y+(m<10?'0'+m:m)+(d<10?'0'+d:d)+(h<10?'0'+h:h)+(i<10?'0'+i:i)+(s<10?'0'+s:s);
	        return this.name+date;
	    }
	},
}
</script>
<style>
.export-excel-wrapper{
	display: inline-block;
	margin:0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/json_data.vue